import { Filter } from '@anytag/shared-molecules';
import { useFacebookInfluencersContext } from '../FacebookInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const FacebookInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useFacebookInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
